import React from "react";
import Navb from "../navbar/Navb";
import Footer from "../footer/Footer";
import Recipie from "../recipie/Recipie";
import Container from "react-bootstrap/Container";
// import Recpiesimg2 from "./recpiesimg2.png";
// import Recpiesimg3 from "./recpiesimg3.png";
// import Recpiesimg4 from "./recpiesimg4.png";
// import Recpiesimg5 from "./recpiesimg5.png";
// import Timer from "../timer.png";
import "./recipiePage.css";
const RecipiePage = (props) => {
  return (
    <>
      <Navb />
      <img
        className="singleRecipeTopimg"
        src={props.Recpiesimg1}
        alt="Recpiesimg1"
        loading="lazy"
        // priority
      />
      <div
        className="singleRecipeTopName"
        style={{ backgroundImage: `url(${props.Img1})` }}
      >
        <img src={props.Recpiesimg2} alt="Recipe img" />
        <div className="singleRecipeTop">{props.Name}</div>
      </div>
      <div style={{ "background-color": "#d9d9d9" }}>
        <Container>
          <div className="singleRecipeBotLeftItemTitle">INGREDIENTS</div>
          <div className="singleRecipeBotLeftItems">
            {/* <hr /> */}
            <div className="singleRecipeBotLeftItem">
              {/* <div className="singleRecipeBotLeftItemTop">For the Dough:</div> */}
              {props.Ul1}

              {props.Ul2}
            </div>
            <div className="singleRecipeBotLeftItem">
              {props.Ul3}
              {props.Ul4}
            </div>
          </div>
        </Container>
      </div>
      <div className="singleRecipeBot">
        <div className="singleRecipeBotRight">
          <div className="singleRecipeBotRightTop">Instructions</div>
          {props.Ol1}
        </div>
      </div>
      <div className="homeRecipies">
        <Recipie
          IMG={props.Recpiesimg3}
          RecipieName={props.Item1}
          RecipieLink={props.Link1}
        />
        <Recipie
          IMG={props.Recpiesimg4}
          RecipieName={props.Item2}
          RecipieLink={props.Link2}
        />
        <Recipie
          IMG={props.Recpiesimg5}
          RecipieName={props.Item3}
          RecipieLink={props.Link3}
        />
      </div>
      <Footer />
    </>
  );
};

export default RecipiePage;
